import React, { Dispatch as ReactDispatch } from 'react'
import { SessionParameters } from '../../types/parameters'

// Create Contexts
const State = React.createContext<Partial<SessionParameters>>({})
const Dispatch = React.createContext<ReactDispatch<Partial<SessionParameters>>>(() => {})

// Initial State
const init: Partial<SessionParameters> = {} // You can define the initial state values here if needed

// Reducer
const reducer = (state: Partial<SessionParameters>, nextState: Partial<SessionParameters>) => {
  const session = {
    ...state,
    ...nextState
  } as Partial<SessionParameters>
  return session
}

// Provider component
interface ProviderProps {
  children: React.ReactNode
}

const Provider: React.FC<ProviderProps> = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, init)

  return (
    <State.Provider value={state}>
      <Dispatch.Provider value={dispatch}>{children}</Dispatch.Provider>
    </State.Provider>
  )
}

// Export
export const Session = {
  State,
  Dispatch,
  Provider
}
